import React from "react";
import { RouterConfig } from "@shared/lib/routerConfig";
import { NoFavoritesIcon } from "@shared/ui/Icon/ui/Statuses/NoFavoritesIcon";
import { NoFavoritesTexts } from "./constants";
import classes from "./NoFavorites.module.scss";

export const NoFavorites = () => {
    return (
        <div className={classes.NoFavorites}>
            <NoFavoritesIcon className={classes.NoFavorites__image} />
            <div className={classes.NoFavorites__content}>
                <h2 className={classes.NoFavorites__title}>{NoFavoritesTexts.TITLE}</h2>
                <p className={classes.NoFavorites__text}>{NoFavoritesTexts.DESCRIPTION}</p>
                <a className={classes.NoFavorites__link} href={RouterConfig.CATALOG}>
                    {NoFavoritesTexts.LINK_TEXT}
                </a>
            </div>
        </div>
    );
};